<div
  fxFlex
  fxLayoutAlign="start center"
  class="time-slot-picker-row"
>
  <div class="time-slot-picker-row__inner">
    <div class="time-slot-picker-row__icon" fxFlex="nogrow" fxLayoutAlign="center center">
      <ng-content select="[icon]"></ng-content>
    </div>

    <div
      fxFlex
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutAlign="space-between center"
      fxLayoutAlign.lt-sm="center"
    >
      <div class="time-slot-picker-row__label">
        <ng-content select="[label]"></ng-content>
      </div>
      <div class="time-slot-picker-row__time">
        <ng-content select="[timeslot]"></ng-content>
      </div>
    </div>

    <div fxFlex="nogrow" fxFlexAlign="center">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>
